var _rect, _rect2, _path, _rect3, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#385EBA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "#385EBA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1133 24.0045C11.6162 23.757 10.5259 22.9338 9.75862 21.9517C8.61546 20.4885 6.96693 18.5578 6.98932 16.7011C7.0124 14.7868 8.87917 12.8608 10.2284 11.5026C12.7228 8.99151 16.3687 9.619 19.5872 9.61899C25.3931 9.61897 26.6343 13.9304 26.8888 13.9304C27.3819 13.9304 27.9009 14.4369 28.0176 16.7011C28.1133 18.5561 26.2684 20.4639 25.0714 21.8843C24.0395 23.1087 22.5846 24.128 20.8916 24.2429C16.8985 24.5137 16.7076 24.5988 13.1133 24.0045Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.1176
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.37109,
    y: 14.7906,
    width: 16.2563,
    height: 6.01687,
    rx: 3.00843,
    fill: "#385EBA",
    stroke: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.4679,
    cy: 17.8181,
    rx: 1.55477,
    ry: 1.75422,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4986,
    cy: 17.8181,
    rx: 1.55477,
    ry: 1.75422,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnsIcon);
export default __webpack_public_path__ + "static/media/ansIcon.4fd078616b8a4f35a54b991375148901.svg";
export { ForwardRef as ReactComponent };